import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

import {addSuccessMessage} from '../SnackBar';

export const COMPETITIONS_POST_REQUEST = 'POST_COMPETITIONS_REQUEST';
export const COMPETITIONS_POST_FAILURE = 'POST_COMPETITIONS_FAILURE';
export const COMPETITIONS_POST_SUCCESS = 'POST_COMPETITIONS_SUCCESS';

export const postCompetition = data => {
    return function(dispatch) {
        dispatch(postRequest());
        return axios(apiRequestOptions(apiPath.COMPETITIONS.POST, data))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(postSuccess(response.data));
                dispatch(addSuccessMessage('Competition successfully added'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRequest = () => {
    return {type: COMPETITIONS_POST_REQUEST}
};

const postFailure = error => {
    return {type: COMPETITIONS_POST_FAILURE, error}
};

const postSuccess = competition => {
    return {type: COMPETITIONS_POST_SUCCESS, competition}
};
